// @flow
import * as React from 'react'
import { Helmet } from 'react-helmet'

type Props = {
  multiLanguagesPaths: Object,
  helmetElements?: Array<React.Node>
}

const HelmetComponent = (props: Props) => (
  <Helmet>
    <link rel='alternate' hreflang='es' href={props.multiLanguagesPaths['es']} />
    <link rel='alternate' hreflang='cat' href={props.multiLanguagesPaths['ca']} />
    {props.helmetElements}
  </Helmet>
)

export default HelmetComponent
